<template lang="pug">
  section.error_404.h-100
    .container-scroller.h-100
      .container-fluid.page-body-wrapper.full-page-wrapper.h-100.p-0
        .content-wrapper.d-flex.align-items-center.text-center.error-page.bg-primary.h-100.px-2
          .flex-grow.w-100
            .col-lg-7.mx-auto.text-white
              .row.align-items-center.d-flex.flex-row
                .col-lg-6.text-lg-right.pr-lg-4
                  h1.display-1.mb-0 404
                .col-lg-6.error-page-divider.text-lg-left.pl-lg-4
                  h2 SORRY!
                  h3.font-weight-light The page you’re looking for was not found.
              .row.mt-5
                .col-12.text-center.mt-xl-2
              .row.mt-5
                .col-12.mt-xl-2
                  p.text-white.font-weight-medium.text-center Copyright © 2020  All rights reserved.
</template>

<script>
export default {
  name: 'error404',
};
</script>

<style scoped lang="scss">
  .error_404 {
    cursor: default;
  }
</style>
